import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Condition } from '../../../models';
import { AdminService, ApiService, AuthService, ConditionService, MetadataService, SessionService, ModalService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { ModalComponent } from '../../modal/modal.component';

@Component({
    selector: 'sn-usc-p2w-competitions',
    templateUrl: './usc-p2w-competitions.component.html',
    styleUrls: ['./usc-p2w-competitions.component.css']
})
export class UscP2wCompetitionsComponent implements OnInit {
    public items: Array<any> = [];
    public columnFields: Array<any> = [];
    private viewConditions: Array<any> = [];
    current_view: string = this.uscStoreService.view_p2w_competitions;
    // search
    public searchText: string;
    // paging 
    public curPage: number = 1;
    public pageSize: number = 15;
    public pageCount: number = 0;
    public itemCount: number = 0;
    public orderBy: string = 'pd_datetime_created';
    public asc: boolean;
    protected conditionResults: Array<Condition> = [];

    constructor(
        //public modalService: ModalService,
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService
    ) {
        console.log('BfpClaimsComponent constructor');
    }

    ngOnInit() {
        this.loadTableViewMetaData();

        // // listen to searchText changes
        // this.beasleyService.searchText.subscribe(
        //     value => {
        //         this.searchText = value;
        //         this.reloadItems(value);
        //     }
        // );
        // listen to new claim creation
        // this.uscStoreService.newClaim.subscribe(
        //     value => {
        //         // reload to get the newly created claim
        //         this.reloadItems();
        //     }
        // );
    }

    loadTableViewMetaData() {
        console.log("loadMetaData");
        // column fields
        this.metadataService.getTableViewMetaData(this.current_view, {}, true).subscribe(result => {
            console.log(result.meta_data.column_fields);
            this.columnFields = result.meta_data.column_fields;
            this.viewConditions = result.meta_data.view_conditions;
            this.setActiveSortColumn(this.orderBy);
            // load view items here after meta data is downloaded
            this.reloadItems();
        });
    }

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType: string = null) {
        var params: any = {}
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (executeScriptType) params.est = executeScriptType;
        params.obd = this.asc ? "asc" : "desc";
        return params;
    }

    getExecuteScriptType(bSearchData: boolean = true, bTotalCount: boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }

    reloadItems(searchText: string = null) {
        var params = this.getSearchParams(this.getExecuteScriptType(true, false));
        if (searchText) params.text = searchText;
        this.apiService.getViewData(this.current_view, params).subscribe(
            result => {
                if (this.viewConditions) {
                    result.items.forEach(i => {
                        var conditions = JSON.parse(JSON.stringify(this.viewConditions));
                        i.viewConditions = this.conditionService.evaluateItemValues(conditions, null, i);
                    });
                }
                this.items = result.items;
                console.log(this.items);
            },
            err => {
                console.log(err);
            }
        );
        var params = this.getSearchParams(this.getExecuteScriptType(false, true));
        if (searchText) params.text = searchText;
        this.apiService.getViewData(this.current_view, params).subscribe(
            result => {
                this.itemCount = result.total_count;
                this.pageCount = Math.ceil(this.itemCount / this.pageSize);
            },
            err => {
                console.log(err);
            }
        );
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            this.reloadItems(this.searchText);
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            this.reloadItems(this.searchText);
        }
    }

    onFieldBtnEvent(btnEvent) {
        console.log(btnEvent);
        switch (btnEvent.btn.event) {
            case "sn_open_modal_view": this.openModalView(btnEvent); break;
            //case "sn_open_modal_component": this.openModalComponent(btnEvent); break;
        }
    }

    openModalView(btnEvent) {
        var data = [];
        var view = "";
        switch (btnEvent.btn.modal_view) {
            case this.uscStoreService.view_p2w_competitions:
                data = btnEvent.item;
                view = btnEvent.btn.modal_view;
                break;
        }

        this.modalService.openContent(
            ModalComponent,
            { view: view, data: data },
            { backdrop: 'static', keyboard: false }
        ).result.then((result) => {
            //this.beasleyService.setNewClaim(result);
            this.sessionService.log(view + ' submitted');
            this.reloadItems();
            }, (reason) => {
                this.sessionService.log('Form Closed');
        })
    }

    // openModalComponent(btnEvent) {
    //     switch (btnEvent.btn.modal_component) {
    //         case "sn-usc-attachment-lookup": this.showAttachments(btnEvent.item); break;
    //     }
    // }

    // showAttachments(item) {
    //     this.modalService.openContent(
    //         AttachmentLookupComponent,
    //         { view: this.view, data: item, related_type: "case", related_ID: item.view_ID, title: "Attachments - Claim #" + item.cs_case_number },
    //         { size: "lg", backdrop: 'static', keyboard: false }
    //     ).result.then((result) => {
    //         console.log(result);
    //     }, (reason) => {
    //         console.log('Attachment Closed');
    //     });
    // }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.orderBy ? true : !this.asc;
        this.orderBy = event.field.key;
        this.setActiveSortColumn(event.field.key);
        this.reloadItems();
    }

    setActiveSortColumn(column_key: string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }

    newCompetition() {
        const modalRef = this.ngbModal.open(ModalComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.view = this.uscStoreService.view_p2w_competitions;   
        let new_competition = { view_ID: 0 };
        modalRef.componentInstance.data = new_competition;
        modalRef.result.then((result) => {
            console.log(result);
            let item: any = {};
        }, (reason) => {
            console.log(reason);
        });
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-p2w-competitions/usc-p2w-competitions.component.ts